"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = void 0;
var tslib_1 = require("tslib");
var ui_box_1 = require("@hopin-team/ui-box");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var styled_system_1 = require("styled-system");
exports.Root = (0, styled_components_1.default)(ui_box_1.Box)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: grid;\n  ", "\n"], ["\n  display: grid;\n  ", "\n"])), styled_system_1.grid);
var templateObject_1;
//# sourceMappingURL=root.js.map